module.exports = __webpack_public_path__ + "img/arrow2.165ca36f.svg";